import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { ConstructionItem } from '~/models/ConstructionItem';

const paths = {
  index: '/construction_items'
};
type TIndex = () => SwrReturnType<ConstructionItem[]>;
type ReturnType = {
  index: TIndex;
};

export const useConstructionItems = (): ReturnType => {
  const index: TIndex = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<ConstructionItem[]>(paths.index);
    return {
      data: data ?? [],
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
